import { UserResponse } from 'core/user/entities';

export type UserResponsesState = {
  [key: string]: UserResponse;
};

export const userResponsesInitialState: UserResponsesState = {};
